import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import OurWorkPage from './pages/OurWorkPage';
import ContactPage from './pages/ContactPage';
import ReviewsPage from './pages/ReviewsPage';
import BookingModal from './components/BookingModal';
import Footer from './components/Footer';
import { Service } from './types';
import './App.css';

function App() {
  const [showBookingModal, setShowBookingModal] = useState(false);
  const [selectedService, setSelectedService] = useState<Service | undefined>();

  const handleBookingClick = () => {
    setShowBookingModal(true);
  };

  const handleServiceSelect = (service: Service) => {
    setSelectedService(service);
    setShowBookingModal(true);
  };

  const handleCloseModal = () => {
    setShowBookingModal(false);
    setSelectedService(undefined);
  };

  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Header onBookingClick={handleBookingClick} />
          
          <Routes>
            <Route 
              path="/" 
              element={
                <HomePage 
                  onBookingClick={handleBookingClick}
                  onServiceSelect={handleServiceSelect}
                />
              } 
            />
            <Route 
              path="/services" 
              element={<ServicesPage onServiceSelect={handleServiceSelect} />} 
            />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/our-work" element={<OurWorkPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
          </Routes>
          
          <Footer />
          
          <BookingModal 
            show={showBookingModal} 
            onHide={handleCloseModal}
            selectedService={selectedService}
          />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
